import Info from '../../../../banking/components/paycheck-routing/info/Info';

export default function PaycheckRoutingInfo() {
    return <Info />;
}
